module.exports = __webpack_public_path__ + "img/moar-traffic-logo.6410f879.svg";